module.exports = __webpack_public_path__ + "img/defaults.229da328.svg";